import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const BankIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 21" {...props}>
            <path
                d="M5 8.17023L5 14.1702"
                fill="none"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 8.17023L10 14.1702"
                fill="none"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15 8.17023L15 14.1702"
                fill="none"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3 16.6702H17"
                fill="none"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17 5.67023H3L10 2.17023L17 5.67023Z"
                fill="none"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
